import React, { Component } from 'react';
import './App.css';

export default class App extends Component {
    static displayName = App.name;
    
    constructor(props) {
        super(props);
        this.state = { 
            books: [], 
            loading: true,
            checkedRows: JSON.parse(localStorage.getItem("checkedRows")) || {}
        };
    }

    componentDidMount() {
        this.getKnittingData();
    }

    toggleRow = (barcode) => {
    this.setState(prevState => {
        const updated = {
            ...prevState.checkedRows,
            [barcode]: !prevState.checkedRows[barcode]
        };

        localStorage.setItem("checkedRows", JSON.stringify(updated));

        return { checkedRows: updated };
    });
};

    static renderBooksTable(books, checkedRows, toggleRow) {
        return (
            <table id='tableDesign' className='tableheader' aria-labelledby="tabelLabel">
                <thead>
                    <tr>
                        <th>Stregkode</th>
                        <th>Antal</th>
                        <th>Tjekket</th>
                    </tr>
                </thead>

                <tbody>
                    {books.map(book => (
                        <tr
                            key={book.barcode}
                            className={checkedRows[book.barcode] ? "checked-row" : ""}
                        >
                            <td>{book.barcode}</td>
                            <td>{book.amount}</td>
                            <td
                                onClick={() => toggleRow(book.barcode)}
                                style={{
                                    cursor: "pointer",
                                    textAlign: "center"
                                }}
                            >
                                {checkedRows[book.barcode] ? "✔" : ""}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading... Please refresh once the ASP.NET backend has started. See <a href="https://aka.ms/jspsintegrationreact">https://aka.ms/jspsintegrationreact</a> for more details.</em></p>
            : App.renderBooksTable(
            this.state.books,
            this.state.checkedRows,
            this.toggleRow
        );
        return (
            <div>
                <div id='contentContainer' className='center'>
                    <h1 id="tabelLabel" >Alle scannede stregkoder</h1>
                    {contents}
                </div>
            </div>
        );
    }

    

    async getKnittingData() {
        const response = await fetch(process.env.REACT_APP_Backed_URL + 'books');
        const data = await response.json();
        this.setState({ books: data, loading: false });
    }
}